<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big">ROYAL<br/><br/>PANOPLY</span><br/><br/></p>
<p class="center"><img alt="" src="OEBPS/images/9780312316433_L02.png"/><br/><br/></p>
<p class="center">BRIEF LIVES OF<br/>THE ENGLISH MONARCHS<br/><br/><br/></p>
<p class="center"><strong>CAROLLY ERICKSON</strong><br/><br/><br/><br/></p>
<p class="center"><span class="small">ST. MARTIN’S PRESS</span><br/><img alt="" src="OEBPS/images/9780312316433_L01.png"/><br/><span class="small">New York</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312316433_epub_tp_r1.vue?79f3d4d2